import { render, staticRenderFns } from "./cv-button.vue?vue&type=template&id=a5971ce4&"
import script from "./cv-button.vue?vue&type=script&lang=js&"
export * from "./cv-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports